<template>
  <div class="products__item-wrap">
    <div
      v-if="system"
      class="products__product-item-container">
      <div
        v-if="system.custom_fields"
        class="product-image-wrap">
        <router-link :to="`/systems/${system.custom_fields.frontend_slug}`">
          <img
            :src="system.custom_fields.product_image.url"
            :alt="system.custom_fields.product_image.alt"
          >
        </router-link>
      </div>
      <h3 class="product__title">{{ system.custom_fields.product_name }}</h3>
      <div
        v-if="system.custom_fields"
        itemprop="description"
        class="product-description-container">
        <p>{{ system.custom_fields.product_description }}</p>
      </div>

      <div class="products__cta-container">
        <router-link
          :to="`systems/${system.custom_fields.frontend_slug}`"
          class="button more-info-button"
        >More Info</router-link>
        <span>Starting at
          <strong>{{ productLowestPrice }}</strong>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    system: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    selectedSize: 'Select a Size'
  }),
  computed: {
    productLowestPrice () {
      return `$${this.system.custom_fields.variations[0].price}`
    }
  },
  methods: {
    prepProductToAdd () {
      // Get currentVariation
      let currentVariation = this.selectedSize
      // Add details needed from parent product
      currentVariation.parentID = this.system.ID
      // Return product
      return currentVariation
    },
    addProduct (variationIndex) {
      if (this.selectedSize !== 'Select a Size') {
        this.$store.commit('cart/ADD_TO_CART', this.prepProductToAdd())
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.products {
  @include e("cta-container") {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;

    .button {
      width: 55%;
      font-size: 15px;
    }

    span {
      margin-left: 30px;
      font-size: 16px;
    }

    @media screen and (max-width: 800px) {
      span {
        margin-left: 45px;
      }
    }
  }
}

.products__product-item-wrap {
  @media (min-width: 650px) and (max-width: 850px) {
    width: 44%;

    &:first-child {
      margin-right: 12%;
    }
  }
}

.products__item-wrap {
  width: 50%;

  @media screen and (max-width: 800px) {
    width: 100%;
  }
}

.products__product-item-container {
  padding: 15px 45px;

  @media screen and (max-width: 1100px) {
    padding: 5px 30px;
  }

  @media screen and (max-width: 800px) {
    max-width: 600px;
    margin: 0 auto;
    padding: 30px 30px;

    a {
      display: block;
    }

    img {
      width: 320px;
    }
  }

  h3 {
    max-width: 400px;
    margin: 0px auto 15px;
    font-size: 28px;
    font-weight: normal;
    line-height: 1em;
    padding-bottom: 15px;
    border-bottom: 1px solid $grey;

    @media screen and (max-width: 800px) {
      font-size: 24px;
    }
  }

  .price {
    display: none;
  }

  .product_title {
    display: none;
  }

  .product-image-wrap {
    text-align: center;
  }

  .product-description-container {
    max-width: 400px;
    margin: 0 auto 20px;
  }

  .mattress-size-options-container {
    padding: 15px 0;
    border-top: 1px solid $grey;
    border-bottom: 1px solid $grey;
    font-weight: bold;

    select {
      margin-bottom: 0;
      padding: 0 15px;
      width: 100%;
    }
  }

  .buy-button {
    @media screen and (max-width: 460px) {
      width: 80%;
      margin: auto;
      margin-top: 25px;
      display: block;
    }
  }

  p {
    margin: 10px 0;
  }

  ul {
    margin: 0;
    padding-left: 14px;

    li {
      margin-bottom: 5px;
      font-size: 16px;
    }
  }

  .products__quantity {
    min-height: 55px;
    margin: 20px 0 0 0;
    padding: 12px 0 0 0;
    border-top: 1px solid $grey;
    border-bottom: 1px solid $grey;
    font-size: 1.25em;

    .quantity-counter {
      float: right;

      .products__quantity-counter-button {
        padding: 2px;
        width: 30px;
        height: 30px;
        display: inline-block;
        color: #fff;
        background-color: $aqua-blue;
        border-radius: 50%;
        text-align: center;
        font-size: 1em;
        cursor: pointer;
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer */
        -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
        -webkit-user-select: none; /* Chrome, Safari, and Opera */
        -webkit-touch-callout: none; /* Disable Android and iOS callouts */
      }

      .quantity-input {
        width: 60px;
        text-align: center;
        border: none;
        padding: 0;
        margin: 0;
      }

      &:after {
        @include clearfix();
      }
    }
  }

  .amazon-logo-link {
    display: inline-block;
    padding-left: 20px;
    min-width: 40%;

    span {
      position: relative;
      top: 2px;
      margin-right: 4px;
      font-size: 1.25em;
    }

    img {
      width: 69px;
      position: relative;
      top: 11px;
    }

    @media screen and (max-width: 460px) {
      display: none;
    }
  }

  @media screen and (max-width: 650px) {
  }
}

.product-description-container {
  padding-bottom: 12px;
  border-bottom: 1px solid #ccc;
}
</style>
